if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cartType = document.body.getAttribute('data-cart-type'); // drawer || notification || page
      if (this.cartType !== "page") {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartModal = this.cartType === "notification" ?
                         document.querySelector('cart-notification') : document.querySelector('cart-drawer'); // could be cart-notification || cart-drawer
      }
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
     // this.cartModal.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if(this.cartType !== "popup"){
      formData.append('sections', this.cartModal.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const forceDrawerOpen = true;
          this.cartModal.renderContents(response, forceDrawerOpen);
          console.log(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');

          if(this.cartType === "popup"){
            this.togglePopup();
          }
          //[START]toggle alert on category page
          this.toggle_alert();
          //[END]toggle alert on category page

          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    togglePopup(){
      let submitBtn = this.form.querySelector('[type="submit"]');
      let product_img = this.querySelector('.product_img');
      if(product_img)
        document.querySelector('.popup-product_info img').src = product_img.value;
      let product_title = this.querySelector('.product_title')
      if(product_title)
      {
        product_title = product_title.value.split(" - ")
        if(product_title)
        {
          document.querySelector('.popup-product_info .product_name').innerHTML = product_title[0];
          document.querySelector('.popup-product_info .prodct_color').innerHTML = product_title[1];
        }
      }
      let product_size = this.querySelector('.product_size');
      if(product_size)
      {
        if(product_size.value != '' )
        document.querySelector('.popup-product_info .prodct_size').innerHTML = product_size.value; 
        else
        {
          let productSizeCont = document.querySelector('.product-size_container');
          if(productSizeCont)
            productSizeCont.remove();
        }
        
      }
      this.update_cartIcon();
      this.show_popup();
      this.disableSubmitBtns();
      setTimeout(this.hide_popup.bind(this), 5000);
    }

    show_popup(){
     let popupElem = document.querySelector('.popup-container');
     if(popupElem){
      popupElem.classList.remove('hide_popup', 'tw-hidden');
      setTimeout(function () {
        popupElem.classList.remove('visuallyhidden');
      }, 20);
     }
   
    }
    
    hide_popup(){
      let popupElem = document.querySelector('.popup-container');
      if(popupElem)
      {
        popupElem.classList.add('visuallyhidden');
        popupElem.addEventListener('transitionend', function(e) {
          popupElem.classList.add('hide_popup')
        }, {
          capture: false,
          once: true,
          passive: false
        });
      }
      setTimeout(this.enableSubmitBtns(), 7000);
    }

    enableSubmitBtns(){
      let btns = document.querySelectorAll('[type="submit"]');
      btns.forEach(function(btn){
        if(!btn.classList.contains('not_available')){
          btn.removeAttribute('aria-disabled');
          btn.style.pointerEvents = "auto";
          btn.style.cursor = "pointer";
          btn.disabled = false;
        }
      })
    }

    disableSubmitBtns(){
      let btns = document.querySelectorAll('[type="submit"]');
      btns.forEach(function(btn){
        btn.setAttribute('aria-disabled', true);
        btn.style.pointerEvents = "none";
        btn.style.cursor = "not-allowed";
        btn.disabled = true;
      })
    }

    update_cartIcon(){
     let cart_count = document.querySelector('.cart_count');
     let cart_heartElem = document.querySelector('.cart_heart');
     let cart_countElem = document.querySelector('.cart-counter');
     let cart_count_num = parseInt(cart_count.value);
     cart_count_num+=1;
     cart_count.value = cart_count_num;
     if(cart_count_num<10)
     {
      if(cart_count_num == 1)
      {
        document.querySelector('.cart-count-bubble').innerHTML = '<span aria-hidden="true" class="cart-counter">'+cart_count_num+'</span>\
        <span class="hidden cart_heart"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-heart" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="16" height="16" viewBox="0 0 256 256" xml:space="preserve"><g transform="translate(128 128) scale(0.72 0.72)" style=""><g style="stroke: white; stroke-width: 2; stroke-dasharray: solid; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: black; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)"><path d="M 45 84.334 L 6.802 46.136 C 2.416 41.75 0 35.918 0 29.716 c 0 -6.203 2.416 -12.034 6.802 -16.42 c 4.386 -4.386 10.217 -6.802 16.42 -6.802 c 6.203 0 12.034 2.416 16.42 6.802 L 45 18.654 l 5.358 -5.358 c 4.386 -4.386 10.218 -6.802 16.42 -6.802 c 6.203 0 12.034 2.416 16.42 6.802 l 0 0 l 0 0 C 87.585 17.682 90 23.513 90 29.716 c 0 6.203 -2.415 12.034 -6.802 16.42 L 45 84.334 z M 23.222 10.494 c -5.134 0 -9.961 2 -13.592 5.63 S 4 24.582 4 29.716 s 2 9.961 5.63 13.592 L 45 78.678 l 35.37 -35.37 C 84.001 39.677 86 34.85 86 29.716 s -1.999 -9.961 -5.63 -13.592 l 0 0 c -3.631 -3.63 -8.457 -5.63 -13.592 -5.63 c -5.134 0 -9.961 2 -13.592 5.63 L 45 24.311 l -8.187 -8.187 C 33.183 12.494 28.356 10.494 23.222 10.494 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: white; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/></g></g></svg>\
        </span>';
     }
      else
      {
        cart_countElem.innerHTML = cart_count_num;
        cart_countElem.classList.remove('hidden');
        cart_heartElem.classList.add('hidden');
      }
     }
     else{
      cart_heartElem.classList.remove('hidden');
      cart_countElem.classList.add('hidden');
     }
    }

    toggle_alert(){
      let product_id = this.getAttribute('data-id');
      if(product_id){
        let category_Elem = document.querySelector('.product-'+product_id);
        if(category_Elem)
        {
          let formElem = category_Elem.querySelector('form');
          if(formElem)
            formElem.classList.toggle('hidden')
          let category_sizeOptionElem = category_Elem.querySelector('.category_size-option')
          if(category_sizeOptionElem)
          {
            category_sizeOptionElem.classList.toggle('hidden');
          }

          let alertElem = category_Elem.querySelector('.added-succesfflly-alert');
          if(alertElem)
            alertElem.classList.toggle('hidden')
        }
      }
    }
    
  });
}
